/**
 * In-place Editor events defined here.
 */
/** @hidden */
export const render = 'render';
/** @hidden */
export const update = 'update';
/** @hidden */
export const destroy = 'destroy';
/** @hidden */
export const setFocus = 'set-focus';
/** @hidden */
export const accessValue = 'access-value';
/** @hidden */
export const destroyModules = 'destroy-modules';
/** @hidden */
export const showPopup = 'show-popup';
